import { render, staticRenderFns } from "./EDIConfiguration.vue?vue&type=template&id=5ad79675&"
import script from "./EDIConfiguration.vue?vue&type=script&lang=js&"
export * from "./EDIConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports